(function () {
  'use strict';

  function handleSwatchClick(event) {
    var label = event.target.closest('.wrap_swatches label[data-variant-image]');
    if (!label) return;

    var imageUrl = label.getAttribute('data-variant-image');
    if (!imageUrl) return;

    var card = label.closest('.card-wrapper');
    if (!card) return;

    var img = card.querySelector('.first_image');
    if (!img) return;

    img.setAttribute('src', imageUrl);
    img.setAttribute('srcset', imageUrl);
  }

  document.addEventListener('click', handleSwatchClick);
})();
